import React, { useState, useEffect } from "react";
import { searchAccounts } from "../../api";
import { jwtDecode } from "jwt-decode";
import { Form, InputGroup } from "react-bootstrap";

function AccountSearch({ onAccountSelect }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [practices, setPractices] = useState([]);
  const [results, setResults] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setResults([]);
      return;
    }

    let cancelled = false;

    const fetchResults = async () => {
      const data = await searchAccounts(searchQuery, practices);
      if (!cancelled) setResults(data || []);
    };

    const debounceTimer = setTimeout(fetchResults, 300);
    return () => {
      cancelled = true;
      clearTimeout(debounceTimer);
    };
  }, [searchQuery, practices]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    const token = sessionStorage.getItem("user");
    const decoded = jwtDecode(token);
    setPractices(decoded.practice);
  };

  const handleAccountClick = (account) => {
    setSelectedAccount(account); // Set the selected account
    onAccountSelect(account); // Pass the selected account to the parent component
    setSearchQuery(""); // Clear the search query
    setResults([]); // Clear results
  };

  const clearSearch = () => {
    setSearchQuery("");
    setResults([]);
    onAccountSelect(null); // Clear selection in parent
  };

  return (
    <div style={{ position: 'relative' }}>
      <InputGroup>
        <InputGroup.Text 
          style={{ 
            backgroundColor: 'rgb(206.6, 226, 254.6)',
            border: '1px solid rgb(206.6, 226, 254.6)',
            borderRight: 'none'
          }}
        >
          <i className="fa-light fa-file-magnifying-glass text-primary"></i>
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Search by the account first name, last name, or ID number"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{
            borderLeft: 'none',
            height: '38px' // Standard Bootstrap button height
          }}
        />
        {searchQuery && (
          <InputGroup.Text 
            onClick={clearSearch}
            style={{ 
              backgroundColor: '#f8f9fa',
              border: '1px solid #ced4da',
              borderLeft: 'none',
              cursor: 'pointer'
            }}
          >
            <i className="fa-solid fa-times text-muted"></i>
          </InputGroup.Text>
        )}
      </InputGroup>
      
      {results.length > 0 && (
        <div 
          className="results-box"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #ced4da',
            borderTop: 'none',
            borderRadius: '0 0 0.375rem 0.375rem',
            boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
            zIndex: 1000,
            maxHeight: '300px',
            overflowY: 'auto'
          }}
        >
          {results.map((account) => {
            // Determine account type badge
            const getBadge = () => {
              if (account.accountIODFund) {
                return (
                  <span className="badge bg-warning text-dark">
                    IOD
                  </span>
                );
              }
              if (account.accountMedicalAid) {
                return (
                  <span className="badge bg-primary">
                    Medical Aid
                  </span>
                );
              }
              return (
                <span className="badge bg-secondary">
                  Private
                </span>
              );
            };

            return (
              <div
                key={account._id}
                className="result-item d-flex justify-content-between align-items-center"
                onClick={() => handleAccountClick(account)}
                style={{
                  cursor: "pointer",
                  padding: '0.5rem 0.75rem',
                  borderBottom: '1px solid #f8f9fa',
                  fontSize: '0.875rem'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f8f9fa';
                  e.currentTarget.style.color = '#0F3490';
                  e.currentTarget.style.fontWeight = 'bold';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white';
                  e.currentTarget.style.color = 'black';
                  e.currentTarget.style.fontWeight = 'normal';
                }}
              >
                <div>
                  <div>
                    <strong>{account.accountNumber}</strong> - {account.accountFirstName} {account.accountLastName}
                  </div>
                  <small className="text-muted">ID: {account.accountIdNumber}</small>
                </div>
                {getBadge()}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AccountSearch;